import Config from '../../../config/Config'
import { map, mergeMap, catchError, withLatestFrom } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { jwtSelector } from '../../auth/selectors'
import * as actions from '../actions'
import queryString from '@promoboxx/query-string-babel'

export const getRetailerAdCreativeTemplateObservable = ([action, state]) => {
  const jwt = jwtSelector(state) || action.payload.jwt
  const params = {
    retailer_id: action.payload.retailerId,
    facebook_page_id: action.payload.facebookPageId,
  }

  const settings = {
    method: 'GET',
    responseType: 'json',
    headers: {
      Authorization: jwt,
    },
    url: `${Config.SERVICE_BASE}/facebookad/v1/adcreative_template/${
      action.payload.id
    }?${queryString.stringify(params)}`,
  }

  const meta = {
    id: action.payload.id,
    retailerId: action.payload.retailerId,
  }

  return ajax(settings).pipe(
    map((payload) => {
      return {
        type: actions.GET_RETAILER_AD_CREATIVE_TEMPLATE_FULFILLED,
        payload: payload.response,
        meta,
      }
    }),
    catchError((payload) => {
      return of({
        type: actions.GET_RETAILER_AD_CREATIVE_TEMPLATE_REJECTED,
        payload: payload.response,
        meta,
      })
    }),
  )
}

export const getRetailerAdCreativeTemplateEpic = (action$, state$) => {
  return action$.pipe(
    ofType(actions.GET_RETAILER_AD_CREATIVE_TEMPLATE),
    withLatestFrom(state$),
    mergeMap(getRetailerAdCreativeTemplateObservable),
    catchError((payload) => {
      return of({
        type: actions.GET_RETAILER_AD_CREATIVE_TEMPLATE_REJECTED,
        payload,
      })
    }),
  )
}
